import React, { useState, useEffect, useCallback } from "react";
//outsource
import { Row, Col, Layout, Button } from "antd";
import { URL } from "../00_Nav/url";
//components
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import LayoutHeader from "../00_Nav/layout/layout_header";
import TimeSheetTopbar from "./component/time_sheet_topbar";
import TimeSheetTable from "./component/time_sheet_table";
import TimeTableEdit from "./component/time_table_edit";
import lodash from "lodash";
import { timeTrackingToReport } from "../../utils/refine.timetracking";
//redux
import { useDispatch, useSelector } from "react-redux";

// import { unSnapStaffs, snapAllStaffs } from "../../store/staff/staff.action";
import { trackingSelector } from "../../store/time_tracking/time_tracking.selector";
import { snapAllUsers, unSnapUsers } from "../../store/user/user.action";
import { usersSelector } from "../../store/user/user.selector";
// import { staffsSelector } from "../../store/staff/staff.selector";
import {
  editSelector,
  from,
  to,
  company,
  dataUser,
} from "../../store/report/report.selector";
import {
  setReportData,
  setTotalWorking,
  setTotalBreaking,
  setRange,
  setEdit,
} from "../../store/report/report.action";
import {
  snapAllTimeTracking,
  unSnapTime,
  updateTimeTracking,
} from "../../store/time_tracking/time_tracking.action";
//sample
// import { createSampleData } from "../../store/dev/dev.action";
// import { TIMESHEET_DATA } from "../../store/data/roster";

//style
import "./style.css";
import LayoutFooter from "../00_Nav/layout/layout_footer";

const { Content } = Layout;
const { orderBy } = lodash;

const TimeTracking = () => {
  // -------------------------- VAR --------------------------

  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Report", url: URL.report },
    { title: "Time Tracking", url: URL.timeTracking },
  ];
  // -------------------------- STATE --------------------------
  const [userId, setUserId] = useState("");
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [trackings, setTrackings] = useState(null);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  //   const trackings = useSelector(trackingSelector);
  const users = useSelector(usersSelector);
  const edit = useSelector(editSelector);
  const companyId = useSelector(company);
  const dataFrom = useSelector(from);
  const dataTo = useSelector(to);

  // console.log({ companyId });
  // -------------------------- FUNCTION --------------------------
  const handleView = () => {
    dispatch(
      snapAllTimeTracking(
        { from: dataFrom, to: dataTo, company: companyId },
        (data) => {
          setTrackings(data);
          console.log({ data });
        }
      )
    );

    return () => dispatch(unSnapTime());
  };

  const handleUpdate = () => {
    if (selected && companyId !== "") {
      setLoading(true);
      dispatch(
        updateTimeTracking({ selected, branch: companyId }, () => {
          setLoading(false);
          dispatch(setEdit({ data: false }));
          setSelected([]);
          // handleView();
        })
      );
    }
  };

  // -------------------------- EFFECT --------------------------

  //staffs
  useEffect(() => {
    dispatch(snapAllUsers());
    return () => dispatch(unSnapUsers());
  }, [dispatch]);

  //filter
  useEffect(() => {
    if (trackings) {
      let inOutData = trackings;
      if (userId !== "") {
        inOutData = inOutData?.filter((item) => item?.user === userId);
      }
      // console.log({inOutData})
      const report = timeTrackingToReport({
        users,
        timeTracking: inOutData,
        from: dataFrom,
        to: dataTo,
      });

      console.log({ report });

      const reportData = orderBy(report?.data, "fullName", ["asc"]);
      const totalWorking = report?.totalWorking;
      const totalBreaking = report?.totalBreaking;
      const range = report?.range;

      //   console.log({ reportData });
      dispatch(setReportData({ data: reportData }));
      dispatch(setTotalWorking({ data: totalWorking }));
      dispatch(setTotalBreaking({ data: totalBreaking }));
      dispatch(setRange({ data: range }));
    }
  }, [dispatch, trackings, userId]);

  useEffect(() => {
    dispatch(setReportData({ data: [] }));
  }, [dataFrom, dataTo, companyId]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row style={{ margin: "20px 0px" }}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <TimeSheetTopbar handleView={handleView} />
        </Col>
        <Col style={{ marginTop: 10 }} xl={24} lg={24} md={24} xs={24}>
          {renderTable()}
        </Col>
        {/* <Col style={{ marginTop: 10 }} xl={24} lg={24} md={24} xs={24}>
          <Button onClick={handleClick}>Create Sample Data</Button>
        </Col> */}
      </Row>
    );
  };

  const renderTable = () => {
    if (!edit) {
      return <TimeSheetTable setUserId={setUserId} userId={userId} />;
    }

    return (
      <TimeTableEdit
        loading={loading}
        selected={selected}
        setSelected={setSelected}
        onUpdate={handleUpdate}
      />
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default TimeTracking;
